import _ from 'underscore';
import addressService from '@bingads-webui-component-legacy/address/service/addressService';
import config from '@bingads-webui-component-legacy/config/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import CallMetering from '@bingads-webui-campaign-legacy/adextension-call/view/call-metering';
import loadAddressFailTemplate from '@bingads-webui-campaign-legacy/adextension-call/template/load-address-fail.pug';
import AdExtensionEditor from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';

const schema = window.globalLegacySchema.get('CallAdExtension');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!global');

export default class CallAdExtensionEditor extends AdExtensionEditor {
  initialize({
    extension,
    data,
  } = {}) {
    const countryCode = extension ? extension.CountryCode : config.get('market') || 'US';

    this.p$init = addressService.load(config.get('culture') || 'en-us', countryCode)
      .then(({ Countries }) => {
        const fields = [{
          property: 'CountryCode',
          control: 'select',
          values: _.map(Countries, (country) => country.Key),
          valueMessages: _.map(Countries, (country) => i18n.getString(`UserCountry_${country.Key}`)),
        }, {
          property: 'PhoneNumber',
          placeholder: i18n.get('AdExtensions_Call_Placeholder_PhoneNumber'),
        }];

        const permissions = config.get('Permissions') || {};

        if (permissions.IsCallMeteringAllowed) {
          fields.push({
            property: 'IsCallTrackingEnabled',
            control: CallMetering,
          }, {
            property: 'RequireTollFreeTrackingNumber',
            visible: false,
          });
        }

        fields.push({
          property: 'IsCallOnly',
          control: 'radios',
        });

        super.initialize({
          extension,
          schema,
          data,
          fields,
        });
      })
      .finally(withUiBlock(this.$el.parent()));
  }

  render() {
    const editorContainerWidth = 700;
    const editorFormContainerWidth = 650;

    this.p$init.then(() => {
      super.render();
      if (_.isFunction(this.setPosition)) {
        this.setPosition();
      }

      this.$('.extension-editor__container').width(editorContainerWidth);
      this.$('.extension-editor__form-container').width(editorFormContainerWidth);
    }).catch(() => {
      this.$el.html(loadAddressFailTemplate({ i18n: i18nGlobal }));
    });

    return this;
  }

  currentModel() {
    const model = super.currentModel();

    if (model.IsCallTrackingEnabled) {
      model.RequireTollFreeTrackingNumber = false;
    } else {
      model.RequireTollFreeTrackingNumber = null;
    }

    return model;
  }
}
